export default {
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/,
  phoneWithNumbers: /^-?\d*(\.\d*)?$/,
  phoneWithNumbersAndDashes: /^\d+(-\d+)*-?$/,
};
